import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const PurchaseTypographyAgreementLinkStyle: StyleExtend<Theme> = {
  color: (theme) => theme.palette.secondary.main,
  textDecorationColor: (theme) => theme.palette.secondary.main,
  fontWeight: 700,
};

export const PurchaseTypographyAgreementStyle: StyleExtend<Theme> = {
  textAlign: 'justify',
  '& .MuiLink-root': PurchaseTypographyAgreementLinkStyle,
};

export const PurchaseNavigationButtonMobileStyle: StyleExtend<Theme> = {
  position: 'fixed',
  width: '100%',
  bottom: 0,
  zIndex: 2,
  left: 0,
  background: (theme) => theme.palette.background.default,
  p: (theme) => theme.spacing(2, 3, 0),
};
